<ng-template #content>
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.invoice.sendEmailModal.title' | translate }}</h4>
      <app-tooltip text="invoiceSendEmail" />
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="form" class="email-form-grid">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.invoice.sendEmailModal.recipient' | translate }}
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control lna"
          [ngClass]="{ 'is-invalid': form.get('recipient')?.invalid && form.get('recipient')?.touched }"
          formControlName="recipient" />
        @if (form.get('recipient')?.invalid && form.get('recipient')?.touched) {
          <p class="error-message">{{ 'components.form.invalidEmail' | translate }}</p>
        }
      </div>
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.invoice.sendEmailModal.subject' | translate }}
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control lna" formControlName="emailSubject" />
      </div>
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.invoice.sendEmailModal.body' | translate }}
          <span class="required-field">*</span>
        </label>
        <div class="textarea-wrapper">
          <textarea class="form-control lna" formControlName="emailBody" rows="8" [maxLength]="MAX_BODY_LENGTH"></textarea>
          <p class="length" [ngClass]="{ invalid: form.get('emailBody')?.value?.length > MAX_BODY_LENGTH }">
            {{ form.get('emailBody')?.value?.length || 0 }}/{{ MAX_BODY_LENGTH }}
          </p>
        </div>
      </div>
      @if (invoice?.informationRequestInvoiceFiles?.length) {
        <div class="lna-row-32 value-wrapper file-list">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.invoice.attachmentFile' | translate }}</label>
          <app-file-upload
            [isEditMode]="false"
            [existingFiles]="invoice!.informationRequestInvoiceFiles || []"
            [type]="fileTypeInvoice"
            [associatedEntityId]="invoice!.id"
            [isSubmitting]="false"
            [showDescription]="false"
            [noPadding]="true" />
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="form.invalid || isLoading" (click)="confirm()">
      {{ 'pages.viewInfoRequest.invoice.sendEmailModal.send' | translate }}
    </button>
    <button class="secondary" (click)="close()">
      {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
    </button>
  </div>
</ng-template>
